var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.108 9.14976L13.1963 6.97218L15.3332 4.84409L13.2449 2.6665L11.1566 4.84409L9.06827 7.02167L5.91154 10.288L4.8431 9.19925L2.7548 7.02167L0.666504 9.19925L2.7548 11.3768L4.8431 13.5544C5.42589 14.1483 6.34862 14.1483 6.9314 13.5544C7.0771 13.406 7.17423 13.2575 7.2228 13.109L7.27136 13.1585L9.0197 11.3273L11.108 9.14976Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b3597271b3210c08d3809fb6d89e786c.svg";
export { ForwardRef as ReactComponent };